module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyList":"No subject attached (empty list)"},"fr":{"emptyList":"Aucun sujet attaché (liste vide)"}}')
  delete Component.options._Ctor
}
